// Copyright 2025 Northern.tech AS
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
import { useEffect, useRef, useState } from 'react';

import { TIMEOUTS } from '@northern.tech/store/commonConstants';

export const InputErrorNotification = ({ className, content }: { className: string; content: string }) => {
  const [isVisible, setIsVisible] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>();

  useEffect(() => {
    if (!content) {
      return;
    }
    setIsVisible(true);
    timer.current = setTimeout(() => setIsVisible(false), TIMEOUTS.fiveSeconds);
    return () => clearTimeout(timer.current);
  }, [content]);

  return <p className={`warning ${isVisible ? 'fadeInSlow' : 'fadeOut'} ${className}`}>{content}</p>;
};
